import { useEffect } from "react";
import updateWorkflowStatus from "@/utils/client/updateWorkflowStatus";

export default function useUpdateWorkflowStatus(
  status: string,
  workflowId: number,
) {
  useEffect(() => {
    const run = async () => {
      await updateWorkflowStatus(status, workflowId);
    };
    run();
    return function cleanup() {
      return;
    };
  }, [status, workflowId]);
}
